import { AnalyticsBrowser } from '@segment/analytics-next';
import { Env } from '@stencil/core';
import { IUser, IOrganization } from '../components/common-header/opti-common-header/opti-common-header';

export async function validateSegmentInstance() {
  try {
    // Check if Segment has already been instantiated
    if (typeof window.segmentAnalytics === 'undefined' || !window.segmentAnalytics.initialize) {
      // initialize Segment if there is no existing instance
      const [analytics] = await AnalyticsBrowser.load({
        writeKey: Env.SEGMENT_KEY,
      });

      // Manually assign to window object for global use
      // AnalyticsBrowser.load does not automatically do this
      window.segmentAnalytics = analytics;
    }
  } catch (ex) {
    console.error(`Error validating Segment instance: ${ex.message}`);
  }
}

export function emitSegmentIdentifyEvent({ organization, user }: { organization: IOrganization; user: IUser }) {
  try {
    window.segmentAnalytics?.identify(user.email, {
      userId: user.email,
      groupId: organization.CrmId,
      organizationId: organization.Id,
      instanceName: organization.Name,
      name: user.name,
      isOptiUser: isOptiUser(user.email),
      // prevent auto-sending group properties from local storage (set by Segment)
      instanceId: undefined,
      groupName: organization.Name
    });
  } catch (ex) {
    console.warn(`Error logging Segment identify event: ${ex.message}`);
  }
}

export function emitSegmentGroupEvent(organization: IOrganization) {
  try {
    window.segmentAnalytics?.group(organization.CrmId, {
      groupId: organization.CrmId,
      organizationId: organization.Id,
      name: organization.Name,
      hasTurnstile: true,
      // prevent auto-sending group properties from local storage (set by Segment)
      instanceId: undefined,
      instanceName: undefined,
    });
  } catch (ex) {
    console.warn(`Error logging Segment group event: ${ex.message}`);
  }
}

export function emitSegmentTrackEvent({ customerId, email, eventName, data }: { customerId: string; email: string; eventName: string; data: any }) {
  try {
    window.segmentAnalytics?.track(eventName, {
      ...data,
      isOptiUser: isOptiUser(email),
      userId: email,
      groupID: customerId,
      productName: 'Common Platform',
      subProductName: 'Global Bar',
    });
  } catch (ex) {
    console.warn(`Error logging Segment track event: ${ex.message}`);
  }
}

function isOptiUser(email) {
  const domainPattern = /@(optimizely\.com|episerver\.net|episerver\.com)$/i;
  return domainPattern.test(email);
}
